import * as React from "react";
import { Toaster } from "../components/ui/toaster";
import { Navbar } from "../components/Navbar";
import { SwapsTableAll } from "../components/SwapsTable";
import { TopupHistory } from "../components/Topups";
import { useState } from "react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";

export function Swaps() {
  const [search, setSearch] = useState("");
  const [showSwaps, setShowSwaps] = useState(true);
  return (
    <div className="flex min-h-screen w-full flex-col">
      <Navbar />
      <main className="flex flex-1 flex-col gap-4 p-4 md:gap-8 md:p-8  overflow-auto">
        <div className="grid gap-4 md:gap-8">
          <div className="flex justify-center">
            <Button
              onClick={() => setShowSwaps(true)}
              variant={showSwaps ? "default" : "outline"}
              className="mr-2"
            >
              Swaps
            </Button>
            <Button
              onClick={() => setShowSwaps(false)}
              variant={!showSwaps ? "default" : "outline"}
            >
              Top-ups
            </Button>
            <Input
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          {showSwaps ? (
            <SwapsTableAll search={search} />
          ) : (
            <TopupHistory search={search} />
          )}
        </div>
      </main>
      <Toaster />
    </div>
  );
}
